import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { color, font, mediaQueries } from 'src/shared/styles/variables';

const NeedMoreHelpWrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 200px',
    backgroundColor: color.dancingDolphinBlue,
    width: '100%',
    borderRadius: '4px',
    [mediaQueries.lg]: {
        padding: '20px 20px',
    },
});

const Wrapper = styled.div({
    width: '100%',
    display: 'flex',
    padding: '24px',
    justifyContent: 'center',
    alignItems: 'center',
});

const NeedMoreHelpText = styled.p({
    color: color.blueBayoux,
    ...font.medium(font.size.medium),
    textAlign: 'center',
});

const ContactUsText = styled.span({
    color: color.blueBayoux,
    textDecoration: 'underline',
    padding: 5,
    cursor: 'pointer',
    ...font.heavy(font.size.medium),
});

export enum ContactUsBannerTestID {
    ContactUsSection = 'ContactUsBanner.ContactUsSection',
}

export interface Props {
    onClick: () => void;
    teletherapyMode?: boolean;
    alreadyMatchedMode?: boolean;
    demographicsMode?: boolean;
    hasDeprecatedProviders?: boolean;
    hasMatchedProviders?: boolean;
    hasUnmatchedProviders?: boolean;
}

export const ContactUsBanner: React.FC<Props> = ({
    alreadyMatchedMode = false,
    teletherapyMode = false,
    onClick,
    demographicsMode = false,
    hasDeprecatedProviders,
    hasMatchedProviders,
    hasUnmatchedProviders,
}) => {
    const { t } = useTranslation();

    let descriptionText = 'end_of_results.description_text';
    let actionText = 'end_of_results.action_text';

    if (alreadyMatchedMode) {
        descriptionText = 'something_different';
    } else if (teletherapyMode) {
        descriptionText = 'different_therapist';
    } else if (demographicsMode && !hasMatchedProviders && !hasUnmatchedProviders) {
        descriptionText = 'no_providers.description_text';
        actionText = 'no_providers.action_text';
    } else if (demographicsMode && hasUnmatchedProviders && hasMatchedProviders) {
        descriptionText = 'other_unmatched_providers.description_text';
        actionText = 'other_unmatched_providers.action_text';
    } else if (demographicsMode && hasUnmatchedProviders && !hasMatchedProviders) {
        descriptionText = 'unmatched_providers.description_text';
        actionText = 'unmatched_providers.action_text';
    } else if (!demographicsMode && !hasDeprecatedProviders) {
        descriptionText = 'no_providers.description_text';
        actionText = 'no_providers.action_text';
    }

    return (
        <Wrapper>
            <NeedMoreHelpWrapper data-testid={ContactUsBannerTestID.ContactUsSection}>
                <NeedMoreHelpText>
                    {t(`providers:provider_selection.contact_us.${descriptionText}`)}
                    <ContactUsText onClick={onClick}>
                        {t(`providers:provider_selection.contact_us.${actionText}`)}
                    </ContactUsText>
                </NeedMoreHelpText>
            </NeedMoreHelpWrapper>
        </Wrapper>
    );
};
